module.exports = __webpack_public_path__ + "img/kol-ai.af77ff90.png";